var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.083 17.083"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_settings_2561383",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(7 7)",
    strokeWidth: 1,
    stroke: "#263360",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M14.451,11.235a1.206,1.206,0,0,0,.241,1.331l.044.044a1.463,1.463,0,1,1-2.069,2.069l-.044-.044a1.216,1.216,0,0,0-2.062.863v.124a1.462,1.462,0,1,1-2.924,0v-.066a1.206,1.206,0,0,0-.79-1.1,1.206,1.206,0,0,0-1.331.241l-.044.044a1.463,1.463,0,1,1-2.069-2.069l.044-.044a1.216,1.216,0,0,0-.863-2.062H2.462a1.462,1.462,0,1,1,0-2.924h.066a1.206,1.206,0,0,0,1.1-.79,1.206,1.206,0,0,0-.241-1.331l-.044-.044A1.463,1.463,0,1,1,5.416,3.405l.044.044A1.206,1.206,0,0,0,6.79,3.69h.058a1.206,1.206,0,0,0,.731-1.1V2.462a1.462,1.462,0,1,1,2.924,0v.066a1.216,1.216,0,0,0,2.062.863l.044-.044a1.463,1.463,0,1,1,2.069,2.069l-.044.044a1.206,1.206,0,0,0-.241,1.331v.058a1.206,1.206,0,0,0,1.1.731h.124a1.462,1.462,0,1,1,0,2.924h-.066A1.206,1.206,0,0,0,14.451,11.235Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#263360",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
};
export default SvgSettings;